const ko = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': '검색 소스 이름',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': '사용자 ID',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'ServiceNow URL',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': '비밀번호',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': '잘못된 URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': '검색 빈도',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    '사용자에게 지식 기반 인증(KBA) 질문에 답변하라는 메시지를 표시합니다.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    '해당 인기 검색 소스 중 하나를 통해 앱과 워크로드를 검색합니다. 미리 채워진 세부 정보, 우선순위가 지정된 권장 사항, 온보딩 상태 전체 보기와 같은 이점을 활용할 수 있습니다.',
  'INTEGRATIONS.DISCOVERY.BACK': '뒤로',
  'INTEGRATIONS.DISCOVERY.TITLE': '검색 설정',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': '서비스 예정...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': '자세히 알아보기',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    '애플리케이션 자격 증명을 입력하여 연결을 설정합니다. 연결되면 데이터를 가져올 수 있습니다.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    '페이지를 로드하는 중에 문제가 발생했습니다.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    '새로고침하거나 나중에 다시 확인하십시오. 문제가 계속될 경우 관리자에게 문의하십시오.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': '다시 로드',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title': '연결 설정',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI 클래스***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': '특성 매핑',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    '연결 세부 정보',
  'INTEGRATIONS.BUTTON.SAVE': '저장',
  'INTEGRATIONS.DISCOVERY.SELECT': '선택',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': '새 연결 생성',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': '이 연결 사용',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow가 저장되었습니다!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    '검색 소스 ServiceNow에 대한 연결이 테스트되고 저장되었습니다. 데이터를 가져와서 검색 설정을 완료합니다. 다음을 건너뛸 수 있습니다.',
  'INTEGRATIONS.DISCOVERY.IMPORT': '자산 가져오기',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': '지금은 건너뛰기',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    '가져오기가 시작되면 취소할 수 없습니다.',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': '안내',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': '기존 연결 선택',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': '연결 이름',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    '{total, plural, one {하나의} other {#}} 기존 연결 구성을 검색했습니다.',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': '가져오기 시작',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Excel 파일에서 데이터를 가져오는 중입니다. 잠시만 기다리십시오...',
  'INTEGRATIONS.TRY.AGAIN': '다시 시도하십시오.',
  'INTEGRATIONS.CLOSE': '닫기',
  'INTEGRATIONS.ERROR.CONNECTION': '연결 오류입니다. 다시 시도하십시오.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    '대기 중에 페이지를 종료할 수 있습니다. 프로세스가 완료되면 알려드리겠습니다.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': '검색 소스 가져오기',
  'INTEGRATIONS.FILEUPLOAD.HEADING': '파일에서 검색 소스 가져오기',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': '샘플 파일 다운로드',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': '검색 소스 이름',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': '파일 이름 입력',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    '올바른 이름을 입력하십시오. 문자, 숫자, 일부 기호만 허용됩니다.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': '업로드 중...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': '계속',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    '다음은 업로드된 XLSX 파일에서 처음 10개의 레코드입니다.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER': '필수 헤더 누락',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    '열 오류가 감지됨',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    '데이터 가져오기를 진행하기 전에 문제를 수정하십시오.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': '가져오기에서 제외',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    '애플리케이션 온보딩 확인',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    '애플리케이션 유형을 식별했습니다. 온보딩하려는 애플리케이션 유형이 올바른지 확인하십시오.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    '온보딩하려는 애플리케이션은 {applicationName}입니다.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    '아니요, 애플리케이션 목록에서 선택합니다.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': '예, 온보딩합니다.',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': '통합',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': '통합 추가',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': '다음에 대한 결과를 찾지 못함',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': '아니요',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX':
    '통합을 찾을 수 없습니다.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': '숨겨진 통합이 없습니다.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': '애플리케이션이 검색됨',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': '소유자:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': '마지막 검색일:',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': '연결 실패',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': '사용자에게 액세스 권한이 있음',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': '검색 소스',
  'INTEGRATIONS.BUTTON.ENABLE': '활성화',
  'INTEGRATIONS.BUTTON.DISABLE': '비활성화',
  'INTEGRATIONS.ENABLING': '활성화',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': '검색',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': '다시 업로드',
  'INTEGRATIONS.DASHBOARD.ONBOARD': '온보딩',
  'INTEGRATIONS.DASHBOARD.HIDE': '숨기기',
  'INTEGRATIONS.DASHBOARD.UNHIDE': '숨기기 해제',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': '검색 구성 탭',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    '저장되지 않은 변경 사항을 취소하시겠습니까?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    '저장되지 않은 변경 사항이 있습니다. 계속하면 변경 사항이 손실됩니다.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': '변경 사항 취소',
  'INTEGRATIONS.BUTTON.CANCEL': '취소',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': '저장 오류',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': '이전 페이지로 돌아가기',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': '애플리케이션 아이콘',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': '수동으로 실행',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': '비활성화 실패',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': '활성화 실패',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    '비활성화되었습니다.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    '활성화되었습니다.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    '현재 다른 가져오기가 진행 중입니다.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    '현재 다른 프로세스에서 자산을 가져오는 중입니다. 나중에 다시 시도하십시오.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': '가져오기 실패',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'ServiceNow에서 자산 가져오기',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    '대기 중에 페이지를 종료할 수 있습니다. 프로세스가 완료되면 알려드리겠습니다.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    '새 특성 매핑 행 추가',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': '속성 추가',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(비어 있음)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': '이 매핑 삭제',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow 필드',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt 필드',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW': 'ServiceNow 특성 검색',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'Saviynt 특성 검색',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(사용자 지정)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': '저장 실패',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': '예약 구성',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': '{timeLabel} UTC.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': '다음 날짜에 반복',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': '다음 요일에 반복',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': '다음 기간마다 반복',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL': '간격 입력',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    '반복 간격(일, 주, 월)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': '일',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': '주',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': '월',
  'INTEGRATIONS.DAYS.SUN': '일',
  'INTEGRATIONS.DAYS.MON': '월',
  'INTEGRATIONS.DAYS.TUE': '화',
  'INTEGRATIONS.DAYS.WED': '수',
  'INTEGRATIONS.DAYS.THU': '목',
  'INTEGRATIONS.DAYS.FRI': '금',
  'INTEGRATIONS.DAYS.SAT': '토',
  'INTEGRATIONS.BUTTON.DISABLING': '비활성화',
  'INTEGRATIONS.BUTTON.SAVED': '저장됨',
  'INTEGRATIONS.BUTTON.SAVING': '저장',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': '비활성화하시겠습니까? ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    '검색 소스를 비활성화하면 자산 가져오기가 중지되며 소스를 구성할 수 없습니다.',
  'INTEGRATIONS.DISCOVERY.HERE': '여기를 클릭하십시오.',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    '검색 소스가 생성되었지만 ServiceNow에 대한 연결에 실패했습니다. 자산 가져오기를 시작하려면 검색 소스 구성 페이지에서 연결 세부 정보를 업데이트하십시오. ',
};

export default ko;
